// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Code = function Code(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.472 2.034a.747.747 0 0 0-.938.493l-4.5 14.5a.75.75 0 0 0 .494.938.75.75 0 0 0 .938-.494l4.5-14.5a.747.747 0 0 0-.494-.937m2.231 3.703a.747.747 0 0 0 .035 1.06l3.415 3.202-3.415 3.204a.75.75 0 0 0 1.025 1.094l4-3.75c.15-.141.237-.341.237-.548a.74.74 0 0 0-.238-.547l-4-3.75a.747.747 0 0 0-1.059.035m-9.406 0a.747.747 0 0 0-1.06-.035l-4 3.75A.74.74 0 0 0 0 10c0 .207.084.407.238.547l4 3.75a.75.75 0 0 0 1.025-1.094L1.847 10l3.416-3.203a.747.747 0 0 0 .034-1.06"
  }));
};
